import { Component } from 'react';
import { bulkActivatePrompts, bulkDisablePrompts } from '../../../PromptManager/query';
import { showMessage } from '../../../../../helpers/showMessage';
import ConfirmationModal from '../../../../../components/Modals/ConfirmationModal';
import AddTags from '../../../PromptManager/modal/AddTags';
import ReactSelect from '../../../../../components/ReactSelect';

class AdditionalBox extends Component {
    constructor() {
        super();

        this.onOpenTagModal = this.onOpenTagModal.bind(this);
        this.onCloseTagModal = this.onCloseTagModal.bind(this);
        this.onCloseConfirmationModal = this.onCloseConfirmationModal.bind(this);
        this.onActivateSelected = this.onActivateSelected.bind(this);
        this.onDisableSelected = this.onDisableSelected.bind(this);
        this.onOpenActivateConfirmationModal = this.onOpenActivateConfirmationModal.bind(this);
        this.onOpenDisableConfirmationModal = this.onOpenDisableConfirmationModal.bind(this);

        this.state = {
            isAddTagsModalOpen: false,
            isOpenConfirmationModal: false,
            confirmFn: () => {},
            confirmationMessage: '',
            loading: false,
        };
    }

    onOpenTagModal() {
        this.setState({ isAddTagsModalOpen: true });
    }

    onCloseTagModal() {
        this.setState({ isAddTagsModalOpen: false });
    }

    onCloseConfirmationModal() {
        this.setState({
            isOpenConfirmationModal: false,
            confirmFn: () => {},
            confirmationMessage: '',
        });
    }

    onOpenActivateConfirmationModal() {
        this.setState({
            confirmFn: this.onActivateSelected,
            isOpenConfirmationModal: true,
            confirmationMessage: this.props.t('ai_tracking.global.activate_message'),
        });
    }
    onOpenDisableConfirmationModal() {
        this.setState({
            confirmFn: this.onDisableSelected,
            isOpenConfirmationModal: true,
            confirmationMessage: this.props.t('ai_tracking.global.disable_message'),
        });
    }

    async onDisableSelected() {
        try {
            this.setState({ loading: true });
            const body = {
                ids: this.props.selectedItems,
            };
            const res = await bulkDisablePrompts(body);
            const data = await res.json();
            if (!res.ok) {
                this.setState({ loading: false });
                return showMessage(data?.detail ?? this.props.t('global.something_went_wrong'));
            }
            this.props.onRemoveAllSelected();
            this.props.getPrompts();
            this.onCloseConfirmationModal();
        } catch (err) {
            console.log(err);
        } finally {
            this.setState({ loading: false });
        }
    }

    async onActivateSelected() {
        try {
            this.setState({ loading: true });
            const body = {
                ids: this.props.selectedItems,
            };
            const res = await bulkActivatePrompts(body);
            const data = await res.json();
            if (!res.ok) {
                this.setState({ loading: false });
                return showMessage(data?.detail ?? this.props.t('global.something_went_wrong'));
            }
            this.props.onRemoveAllSelected();
            this.props.getPrompts();
            this.onCloseConfirmationModal();
        } catch (err) {
            console.log(err);
        } finally {
            this.setState({ loading: false });
        }
    }

    render() {
        const { t } = this.props;

        const options = [
            { label: 'All', value: 'all' },
            { label: 'Active', value: 'active' },
            { label: 'Inactive', value: 'inactive' },
        ];

        return (
            <>
                <div className="table-additional-view justify-content-between">
                    <div>
                        <ReactSelect
                            options={options}
                            value={options.find((x) => x.value === this.props.selectedStatus)}
                            // label="Start Date"
                            isSearchable={false}
                            placeholder="Select Status"
                            onChange={this.props.handleSelectStatus}
                            blurInputOnSelect={true}
                            classname="mr-10"
                        />
                    </div>
                    <div className="table-additional-view-btns ">
                        <button
                            className={'table-additional-view-btn '}
                            disabled={this.props.selectedItems.length === 0}
                            onClick={this.onOpenTagModal}
                        >
                            {t('ai_tracking.global.add_tags')}
                        </button>
                        <button
                            disabled={this.props.selectedItems.length === 0}
                            className={'table-additional-view-btn'}
                            onClick={this.onOpenActivateConfirmationModal}
                        >
                            {t('ai_tracking.global.activate')}
                        </button>
                        <button
                            disabled={this.props.selectedItems.length === 0}
                            className={'table-additional-view-btn'}
                            onClick={this.onOpenDisableConfirmationModal}
                        >
                            {t('ai_tracking.global.deactivate')}
                        </button>
                    </div>
                </div>
                <AddTags
                    selectedItems={this.props.selectedItems}
                    isOpen={this.state.isAddTagsModalOpen}
                    onClose={this.onCloseTagModal}
                    getPrompts={this.props.getPrompts}
                    onRemoveAllSelected={this.props.onRemoveAllSelected}
                />
                <ConfirmationModal
                    isOpen={this.state.isOpenConfirmationModal}
                    message={this.state.confirmationMessage}
                    onClose={this.onCloseConfirmationModal}
                    onSubmit={this.state.confirmFn}
                    cancleBtn={t('ai_tracking.global.no')}
                    buttonName={t('ai_tracking.global.yes')}
                    loading={this.state.loading}
                />
            </>
        );
    }
}

export default AdditionalBox;
